import type { RouterConfig } from 'nuxt/schema';

/**
 * Melhora a navegação em SPA: volta ao topo em novas rotas,
 * preserva posição no histórico (voltar/avançar) e respeita âncoras #hash.
 */
export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
    return { top: 0, left: 0 };
  },
};
